import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <footer id="made-by">
      <div className="footer-container">
        <h1>MadeBy</h1>
        <p>
          <a
            href="https://www.bitmoremedia.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="link-text">BitMoreMedia</span>
          </a>&nbsp; &#169; 2016
        </p>
      </div>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js